import axios from "axios";
import { Eye } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation, useNavigate } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import "../../Assests/css/aplicationform.css";
import {
  handleAlphabetsNumberWithoutSpaceChange,
  handleError,
  validateMobileUSA,
} from "../../CommonJquery/CommonJquery";
import { retrieveData, storeData } from "../../LocalConnection/LocalConnection";
import {
  APL_LINK,
  get_booking_data_main,
  save_booking_Aggrement,
  save_image_pdf,
  server_post_data,
} from "../../ServiceConnection/serviceconnection";
import Layout from "../Layout/Layout";
const Agreement = () => {
  // Add this array at the top of your component, after the useState declarations
  const usStates = [
    { name: "Alabama", abbr: "AL" },
    { name: "Alaska", abbr: "AK" },
    { name: "Arizona", abbr: "AZ" },
    { name: "Arkansas", abbr: "AR" },
    { name: "California", abbr: "CA" },
    { name: "Colorado", abbr: "CO" },
    { name: "Connecticut", abbr: "CT" },
    { name: "Delaware", abbr: "DE" },
    { name: "Florida", abbr: "FL" },
    { name: "Georgia", abbr: "GA" },
    { name: "Hawaii", abbr: "HI" },
    { name: "Idaho", abbr: "ID" },
    { name: "Illinois", abbr: "IL" },
    { name: "Indiana", abbr: "IN" },
    { name: "Iowa", abbr: "IA" },
    { name: "Kansas", abbr: "KS" },
    { name: "Kentucky", abbr: "KY" },
    { name: "Louisiana", abbr: "LA" },
    { name: "Maine", abbr: "ME" },
    { name: "Maryland", abbr: "MD" },
    { name: "Massachusetts", abbr: "MA" },
    { name: "Michigan", abbr: "MI" },
    { name: "Minnesota", abbr: "MN" },
    { name: "Mississippi", abbr: "MS" },
    { name: "Missouri", abbr: "MO" },
    { name: "Montana", abbr: "MT" },
    { name: "Nebraska", abbr: "NE" },
    { name: "Nevada", abbr: "NV" },
    { name: "New Hampshire", abbr: "NH" },
    { name: "New Jersey", abbr: "NJ" },
    { name: "New Mexico", abbr: "NM" },
    { name: "New York", abbr: "NY" },
    { name: "North Carolina", abbr: "NC" },
    { name: "North Dakota", abbr: "ND" },
    { name: "Ohio", abbr: "OH" },
    { name: "Oklahoma", abbr: "OK" },
    { name: "Oregon", abbr: "OR" },
    { name: "Pennsylvania", abbr: "PA" },
    { name: "Rhode Island", abbr: "RI" },
    { name: "South Carolina", abbr: "SC" },
    { name: "South Dakota", abbr: "SD" },
    { name: "Tennessee", abbr: "TN" },
    { name: "Texas", abbr: "TX" },
    { name: "Utah", abbr: "UT" },
    { name: "Vermont", abbr: "VT" },
    { name: "Virginia", abbr: "VA" },
    { name: "Washington", abbr: "WA" },
    { name: "West Virginia", abbr: "WV" },
    { name: "Wisconsin", abbr: "WI" },
    { name: "Wyoming", abbr: "WY" },
    { name: "District of Columbia", abbr: "DC" },
  ];
  const location = useLocation();
  const navigate = useNavigate();
  const { bookingId, carId } = location.state;
  const [step, setStep] = useState(1);
  const maxDob = new Date();
  const [agreed, setAgreed] = useState(false);
  const [numberOfDays, setNumberOfDays] = useState(null);
  const [rideshare, setrideshare] = useState(null);
  const [totalCost, setTotalCost] = useState(null);
  const [licenseImage, setLicenseImage] = useState("");
  const [ridesharImag, setridesharImag] = useState("");
  const [fileType, setFileType] = useState("");
  const [fileData, setFileData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [isPdfFile, setIsPdfFile] = useState(false);
  const [isPdfFile2, setIsPdfFile2] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [imageLoadError, setImageLoadError] = useState(false);
  maxDob.setFullYear(maxDob.getFullYear() - 16);
  const customer_id = retrieveData("customer_id");
  const customer_name = retrieveData("customer_name");
  const customer_email = retrieveData("customer_email");
  const [showPopup, setShowPopup] = useState(false);
  const [termConditionModal, setTermConditionModal] = useState(false);
  const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(false);
  const [drivingState, setdrivingState] = useState(true);
  const dob_date = retrieveData("dob_date");
  const driving_expiration_date = retrieveData("driving_expiration_date");
  const drving_licence_no = retrieveData("drving_licence_no");
  const emergency_contacts = retrieveData("emergency_contacts");
  const emergency_contacts1 = retrieveData("emergency_contacts1");
  const emergency_contacts_name = retrieveData("emergency_contacts_name");
  const emergency_contacts_name1 = retrieveData("emergency_contacts_name1");
  const [successModal, setSuccessModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const emergency_contacts_relation = retrieveData(
    "emergency_contacts_relation"
  );
  const emergency_contacts_relation1 = retrieveData(
    "emergency_contacts_relation1"
  );
  const present_map_address = retrieveData("present_map_address");

  const nameParts = customer_name.trim().split(" ");
  const first_name = nameParts.length > 0 ? nameParts[0] : "";
  const last_name = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
  const [signatureFile, setSignatureFile] = useState(null);
  const [bookingCarData, setBookingCardata] = useState([]);
  const [cardatabooking, setcardatabooking] = useState([]);
  const [formData, setFormData] = useState({
    mvrDownloaded: "yes",
    mvrFile: null,
    driving_licence_image: null,
    feeAgreement: "",
    firstName: first_name,
    lastName: last_name,
    dob: dob_date,
    drivingState: "",
    licenseState: "",
    licenseExpiry: driving_expiration_date,
    phone: "",
    address: present_map_address,
    email: customer_email,
    ssn: "",
    license: drving_licence_no || '',
    // rideshareApproval: "no",
    hireExperience: "",
    carPreference: [],
    rentalDuration: "",
    rentalStart: "",
    carUsage: [],
    carUsageOther: "",
    workApproval: [],
    workApprovalOther: "",
    rideshare_aproval_image: null,
    emergencyContact1: {
      name: emergency_contacts_name,
      relation: emergency_contacts_relation,
      phone: emergency_contacts,
    },
    emergencyContact2: {
      name: emergency_contacts_name1,
      relation: emergency_contacts_relation1,
      phone: emergency_contacts1,
    },
    city: "",
    zipcode: "",
    submissionDate: "",
    signature_image: null,
  });

  const handleChange = async (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "phone" || name === "zipcode") {
      // Remove non-digit characters and limit to 10 digits
      const formattedPhone = value.replace(/\D/g, "").slice(0, 10);
      setFormData({ ...formData, [name]: formattedPhone });
    } else if (type === "checkbox") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked
          ? [...prevData[name], value]
          : prevData[name].filter((item) => item !== value),
      }));
    } else if (type === "file") {
      let data = await handlesaveImage(e.target.files[0]);
      setFormData({ ...formData, [name]: data });
      // setFormData({ ...formData, [name]: e.target.files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handlesaveImage = async (file) => {
    if (!file) return "";

    let data = "";
    let fd_from = new FormData();
    fd_from.append("image", file);

    try {
      const response = await server_post_data(save_image_pdf, fd_from);
      if (response.error) {
        handleError(response.data.message);
      } else {
        data = response.message.image;
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }

    return data;
  };


  useEffect(() => {
    master_data_get();
  }, []);

  const master_data_get = async () => {
    const fd = new FormData();
    fd.append("booking_id", bookingId);
    await server_post_data(get_booking_data_main, fd)
      .then((Response) => {
        if (Response.error) {
          handleError(Response.message);
        } else {
          let finaldata = Response.message.data;
          console.log("dsdsd", finaldata);
          let workApprovalData = [];
          let workApprovalOtherData = "";

          if (finaldata.work_for) {
            const [mainPart, otherPart] = finaldata.work_for.split("~@~");
            workApprovalData = mainPart.split(",");
            workApprovalOtherData = otherPart || "";

            if (workApprovalOtherData) {
              workApprovalData.push("Other"); // Display "Other" in checkbox
            }
          }

          let usingCarForData = [];
          let usingCarForOtherData = "";

          if (finaldata.using_car_for) {
            const [mainPart, otherPart] = finaldata.using_car_for.split("~@~");
            usingCarForData = mainPart.split(",");
            usingCarForOtherData = otherPart;

            if (usingCarForOtherData) {
              usingCarForData.push("Other"); // Display "Other" in checkbox
            }
          }

          const licenseImageUrl =
            APL_LINK +
              Response.message.image_link +
              finaldata.driving_licence_image || "";
          setLicenseImage(licenseImageUrl);

          const rideshareImageUrl =
            APL_LINK +
              Response.message.image_link +
              finaldata.rideshare_aproval_image || "";
          setridesharImag(rideshareImageUrl);

          if (licenseImageUrl) {
            const fileExtension = licenseImageUrl
              .split(".")
              .pop()
              .toLowerCase();

            if (["pdf"].includes(fileExtension)) {
              setFileType("pdf");
            } else if (
              ["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension)
            ) {
              setFileType("image");
            } else {
              setFileType("unknown");
            }
          }
          setcardatabooking(Response.message.car_data);
          setrideshare(finaldata.ready_for_rideshare);
          setBookingCardata(finaldata);
          setFormData({
            mvrDownloaded: "yes",
            mvrFile: null,
            driving_licence_image: finaldata.driving_licence_image || "",
            feeAgreement: "",
            firstName: finaldata.first_name,
            lastName: finaldata.last_name,
            dob: "",
            drivingState: finaldata.state,
            licenseState: "",
            licenseExpiry: "",
            phone: finaldata.mobile_no,
            address: finaldata.present_map_address,
            email: finaldata.email,
            ssn: finaldata.last_digit_ssn,
            license: finaldata.driving_licence,
            // rideshareApproval: "no",
            hireExperience: finaldata.passenger_for_hire_expe,
            carPreference: [],
            rentalDuration: finaldata.long_need_car,
            rentalStart: "",
            carUsage: finaldata.using_car_for
              ? finaldata.using_car_for
                  .split(",")
                  .map((item) => item.trim())
                  .filter(Boolean)
              : [],
            carUsageOther: usingCarForOtherData,
            workApproval: finaldata.work_for
              ? finaldata.work_for
                  .split(",")
                  .map((item) => item.trim())
                  .filter(Boolean)
              : [],
            workApprovalOther: workApprovalOtherData,
            rideshare_aproval_image: null,
            emergencyContact1: {
              name: "",
              relation: "",
              phone: "",
            },
            emergencyContact2: {
              name: "",
              relation: "",
              phone: "",
            },
            city: finaldata.city,
            zipcode: finaldata.pin_code,
            submissionDate: "",
            signature_image: finaldata.signature_image,
          });
          setSignatureFile(
            APL_LINK +
              Response.message.image_link_signature +
              finaldata.signature_image
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchFileForPreview = async (url) => {
    setIsLoading(true);
    setLoadError(false);

    try {

      // Determine file type from URL extension
      const extension = url.split(".").pop().toLowerCase();
      const isPdf = extension === "pdf";
      setFileType(isPdf ? "pdf" : "image");

      // Use axios to fetch the file as a blob
      const response = await axios.get(url, {
        responseType: "blob",
        withCredentials: true, // Include cookies if needed for auth
      });
      // Create a local object URL from the blob
      const objectUrl = URL.createObjectURL(response.data);
      setFileData(objectUrl);
      setLoadError(false);
    } catch (error) {
      console.error("Error fetching file:", error);
      setLoadError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
    window.scrollTo(0, 0); // Scroll to top when navigating back
  };
  const [errors, setErrors] = useState({});

  const step1Errors = () => {
    let errors = {};

    if (!formData.firstName) errors.firstName = "First name is required.";
    if (!formData.lastName) errors.lastName = "Last name is required.";
    if (!formData.dob) errors.dob = "Date of Birth is required.";
    // if (!formData.licenseExpiry)
    //   errors.licenseExpiry = "License Expiry date is required.";
    if (!formData.phone) {
      errors.phone = "Phone number is required.";
    } else {
      // Remove any non-digit characters
      const phoneNumber = formData.phone.replace(/\D/g, "");

      // Check if the phone number is exactly 10 digits
      if (phoneNumber.length !== 10) {
        errors.phone = "Phone number must be 10 digits long.";
      } else {
        // Additional validation for common US phone number formats
        const firstThreeDigits = phoneNumber.substring(0, 3);
        const invalidAreaCodes = ["000", "111", "911"];

        if (invalidAreaCodes.includes(firstThreeDigits)) {
          errors.phone = "Invalid phone number format.";
        }
      }
    }
    if (!formData.email) errors.email = "Email is required.";
    if (!formData.address) errors.address = "Address is required.";
    if (!formData.city) errors.city = "City is required.";
    if (!formData.zipcode) errors.zipcode = "Zipcode is required.";
    // if (!formData.driving_licence_image)
    //   errors.driving_licence_image = "Please upload a PDF of your license.";
    if (!formData.drivingState) errors.drivingState = "Please select a state.";
    return errors;
  };
  const validate = () => {
    let newErrors = {};
    if (!formData.ssn) {
      newErrors.ssn = "SSN is required.";
    } else {
      // Remove any non-digit characters
      const phoneNumber = formData.ssn.replace(/\D/g, "");

      // Check if the phone number is exactly 10 digits
      if (phoneNumber.length < 4) {
        newErrors.ssn = "SSN must be 4 digits long.";
      }
    }
    if (!formData.license) {
      newErrors.license = "Driver's license is required.";
    } else {
      // Check if the phone number is exactly 10 digits
      if (formData?.license.length < 8) {
        newErrors.license = "Enter a valid license number.";
      }
    }

    if (!formData.licenseState)
      newErrors.licenseState = "Please select a state.";
    if (rideshare === "no") {
      if (formData.carUsage.length === 0)
        newErrors.carUsage = "Please select at least one usage.";
      if (formData.carUsage.includes("Other") && !formData.carUsageOther)
        newErrors.carUsageOther = "Specify other car usage.";
    } else {
      if (formData.workApproval.length === 0)
        newErrors.workApproval = "Please select at least one approval.";
      if (
        formData.workApproval.includes("Other") &&
        !formData.workApprovalOther
      )
        newErrors.workApprovalOther = "Specify other platform.";
    }
    if (!formData.licenseExpiry) {
      newErrors.licenseExpiry = "License expiry date is required.";
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Normalize to start of day
      const expiryDate = new Date(formData.licenseExpiry);
      if (isNaN(expiryDate.getTime())) {
        newErrors.licenseExpiry = "Invalid license expiry date.";
      } else if (expiryDate <= today) {
        newErrors.licenseExpiry = "License expiry date must be in the future.";
      }
    }
    // Emergency Contact 1 validation
    if (!formData.emergencyContact1.name) {
      newErrors.emergencyContact1_name = "Name is required.";
    }
    if (!formData.emergencyContact1.relation) {
      newErrors.emergencyContact1_relation = "Relation is required.";
    }
    if (!formData.emergencyContact1.phone) {
      newErrors.emergencyContact1_phone = "Phone Number is required.";
    } else if (!/^\d{10}$/.test(formData.emergencyContact1.phone)) {
      newErrors.emergencyContact1_phone = "Phone Numbner must be 10 digits.";
    }

    // Emergency Contact 2 validation
    if (!formData.emergencyContact2.name) {
      newErrors.emergencyContact2_name = "Name is required.";
    }
    if (!formData.emergencyContact2.relation) {
      newErrors.emergencyContact2_relation = "Relation is required.";
    }
    if (!formData.emergencyContact2.phone) {
      newErrors.emergencyContact2_phone = "Phone Number is required.";
    } else if (!/^\d{10}$/.test(formData.emergencyContact2.phone)) {
      newErrors.emergencyContact2_phone = "Phone Numbner must be 10 digits.";
    }
    // Validate Emergency Contacts and Compare
    if (formData.emergencyContact2.name == formData.emergencyContact1.name)
      newErrors.emergencyContactsame =
        "Names must not match. Please enter two different names.";
    if (formData.emergencyContact2.phone == formData.emergencyContact1.phone)
      newErrors.emergencyContactsame =
        "Phone Numbers must not match. Please enter two different Numbers.";
    setErrors(newErrors);
    // setTermConditionModal(true)
    return Object.keys(newErrors).length === 0;
  };

  const validateTerms = () => {
    let newErrors = {};
    // Terms and Conditions Step 3 validations
    if (step === 3) {
      if (!formState.tollsTicketAgree) {
        newErrors.tollsTicketAgree = "You must agree to Tolls and Tickets.";
      }
      if (!formState.disclosureAgree) {
        newErrors.disclosureAgree = "You must agree to the Disclosure.";
      }
      if (Object.values(formState.dos).some((checked) => !checked)) {
        newErrors.dos = "You must agree to all DO's.";
      }
      if (Object.values(formState.donts).some((checked) => !checked)) {
        newErrors.donts = "You must agree to all DON'Ts.";
      }
      if (!formState.dosAndDontsAgree) {
        newErrors.dosAndDontsAgree = "You must agree to Do's & Dont's.";
      }
      if (formState.parkingOption.length === 0) {
        newErrors.parkingOption = "Please select at least one parking option.";
      }
      if (
        formState.parkingOption.includes("Other") &&
        !formState.otherParkingOption
      ) {
        newErrors.otherParkingOption = "Please specify your parking option.";
      }
      if (!formState.roadsideAssistant) {
        newErrors.roadsideAssistant =
          "Please select a Roadside Assistant option.";
      }
      if (!formState.insuranceAgree) {
        newErrors.insuranceAgree = "You must agree to the Car Insurance terms.";
      }
    }
    setFormErrors(newErrors); // Async update to UI

    const isValid = Object.keys(newErrors).length === 0;

    if (isValid) {
      setTermConditionModal(true); // ✅ Only open modal if no errors
    }

    return isValid;
  };

  const [formState, setFormState] = useState({
    terms1to3c: false,
    terms4to5: false,
    tollsTicketAgree: false,
    disclosureAgree: false,
    dos: { 0: false, 1: false, 2: false, 3: false, 4: false, 5: false },
    donts: {
      0: false,
      1: false,
      2: false,
      3: false,
      4: false,
      5: false,
      6: false,
    },
    dosAndDontsAgree: false,
    parkingOption: [],
    otherParkingOption: "",
    roadsideAssistant: "",
    insuranceAgree: false,
    paymentOption: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const handleNext = () => {
    if (step === 1) {
      const errors = step1Errors();
      if (Object.keys(errors).length > 0) {
        setErrors(errors);
        return;
      }
      setStep(2);
    } else if (step === 2) {
      if (validate()) {
        setStep(3);
      }
    }
    window.scrollTo(0, 0); // Scroll to top when navigating to next step
  };
  const handleCheckboxChange = (e) => {
    setAgreed(e.target.checked);
  };


  const signaturePad = useRef(null);

  const handleClearSignature = () => {
    signaturePad.current.clear();
  };

  const handleEditSignature = () => {
    setIsEdit(!isEdit);
  };

  const handleSaveSignature = () => {
    if (!signaturePad.current || signaturePad.current.isEmpty()) {
      alert("Please provide a signature before proceeding.");
      return;
    }

    const signatureData = signaturePad.current.toDataURL("image/png");

    const base64String = signatureData.split(",")[1];
    const byteArray = new Uint8Array(
      atob(base64String)
        .split("")
        .map((c) => c.charCodeAt(0))
    );
    const blob = new Blob([byteArray], { type: "image/png" });
    const file = new File([blob], "signature.png", { type: "image/png" });

    // setSignatureFile(file);
    setFormData((prevData) => ({
      ...prevData,
      signature_image: file,
    }));

    alert("Signature saved as PNG and downloaded!");
  };

  const handleSubmitImg = async () => {
    let fd_from = new FormData();
    fd_from.append("signature_image", formData.signature_image);
    fd_from.append(
      "emergency_contacts_relation1",
      formData.emergencyContact2.relation
    );
    fd_from.append("emergency_contacts_name1", formData.emergencyContact2.name);
    fd_from.append("emergency_contacts1", formData.emergencyContact2.phone);
    fd_from.append(
      "emergency_contacts_relation",
      formData.emergencyContact1.relation
    );
    fd_from.append("emergency_contacts_name", formData.emergencyContact1.name);
    fd_from.append("emergency_contacts", formData.emergencyContact1.phone);

    {
      rideshare === "no" && fd_from.append("using_car", formData.carUsage);
      // : fd_from.append("work_for", "");
    }
    {
      rideshare === "yes" && fd_from.append("work_for", formData.workApproval);
      // : fd_from.append("using_car", "")
    }

    fd_from.append("long_need_car", formData.rentalDuration);
    fd_from.append("passenger_for_hire_expe", "");
    fd_from.append("ready_for_rideshare", "");
    fd_from.append("driving_licence", formData.license);
    fd_from.append("last_digit_ssn", formData.ssn);
    fd_from.append("present_map_address", formData.address);
    fd_from.append(
      "driving_expiration_date",
      formatDateTimenew(formData.licenseExpiry)
    );
    fd_from.append("mvr_pdf", formData.mvrFile);
    fd_from.append("mvr_status", formData.mvrDownloaded);
    fd_from.append("driving_licence_image", "");
    fd_from.append("end_date", "1");
    fd_from.append("from_date", "2025-03-26");
    fd_from.append("car_id", carId);
    fd_from.append("booking_id", bookingId);
    fd_from.append("car_price", "23");
    fd_from.append("total_price", totalCost);
    fd_from.append("mobile_no", formData.phone);
    fd_from.append("email", formData.email);
    fd_from.append("dob", formatDateTimenew(formData.dob));
    fd_from.append("last_name", formData.lastName);
    fd_from.append("first_name", formData.firstName);
    fd_from.append("state_dropdown", formData.licenseState);
    fd_from.append("driving_state", formData.drivingState);
    fd_from.append("pin_code", formData.zipcode);

    fd_from.append(
      "terms_annd_condition",
      formState.terms1to3c === true ? 1 : 0
    );
    fd_from.append(
      "agree_for_tolls_ticket",
      formState.tollsTicketAgree === true ? 1 : 0
    );
    fd_from.append(
      "agree_for_discloser",
      formState.disclosureAgree === true ? 1 : 0
    );
    fd_from.append(
      "agree_for_do_and_dont",
      formState.dosAndDontsAgree === true ? 1 : 0
    );
    fd_from.append("aggriment_status", 1);
    fd_from.append("aaa_road_side_assistance", formState.roadsideAssistant);
    fd_from.append(
      "car_insurance_terms_condition",
      formState.insuranceAgree === true ? 1 : 0
    );
    fd_from.append(
      "rental_shall_condition",
      formState.terms4to5 === true ? 1 : 0
    );
    fd_from.append("paymentOption", formState.paymentOption);
    // fd_from.append("otherParkingOption", formState.otherParkingOption);

    if (formState.otherParkingOption === "Other") {
      // Ensure roadsideAssistant is an array

      fd_from.append(
        "roadsideAssistant",
        formState.parkingOption.push(formState.otherParkingOption)
      );
      // const updatedRoadsideAssistant = Array.isArray(formState.parkingOption)
      //   ? [...formState.roadsideAssistant, formState.otherParkingOption]
      //   : [formState.otherParkingOption];

      // fd_from.append("roadsideAssistant", updatedRoadsideAssistant);
    } else {
      fd_from.append("roadsideAssistant", formState.parkingOption);
    }

    const dosValues = Object.values(formState.dos)
      .filter((val) => val && val !== false)
      .join("~@~");

    const dontsValues = Object.values(formState.donts)
      .filter((val) => val && val !== false)
      .join("~@~");

    fd_from.append("agrriment_do_value", dosValues);
    fd_from.append("agrriment_do_not_value", dontsValues);

    await server_post_data(save_booking_Aggrement, fd_from)
      .then((Response) => {
        if (Response.error) {
          handleError(Response.data.message);
        } else {
          storeData("dob_date", formData.dob);
          storeData("driving_expiration_date", formData.licenseExpiry);
          storeData("emergency_contacts", formData.emergencyContact1.phone);
          storeData("emergency_contacts1", formData.emergencyContact2.phone);
          storeData("emergency_contacts_name", formData.emergencyContact1.name);
          storeData(
            "emergency_contacts_name1",
            formData.emergencyContact2.name
          );
          storeData(
            "emergency_contacts_relation",
            formData.emergencyContact1.relation
          );
          storeData(
            "emergency_contacts_relation1",
            formData.emergencyContact2.relation
          );
          storeData("present_map_address", formData.address);
          storeData(
            "customer_name",
            formData.firstName + " " + formData.lastName
          );

          // navigate("/my_bookings");
          return Promise.resolve();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  function formatDateTime(date) {
    const d = new Date(date);

    // Get date components
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(d.getDate()).padStart(2, "0");

    // Get time components
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");

    // Combine into desired format
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  function formatDateTimenew(date) {
    const d = new Date(date);

    // Get date components
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(d.getDate()).padStart(2, "0");

    // Combine into desired format
    return `${year}-${month}-${day}`;
  }

  // Handle changes in the emergency contact fields
  const handleEmergencyChange = (e, contactNumber) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [`emergencyContact${contactNumber}`]: {
        ...prevData[`emergencyContact${contactNumber}`],
        [name]: value,
      },
    }));
  };
  const formatDate1 = (dateStr) => {
    if (!dateStr) return "NA";
    const date = new Date(dateStr);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };
  const [isFinalCheckboxEnabled, setIsFinalCheckboxEnabled] = useState(false);
  const [agreed2, setAgreed2] = useState(false);
  const termsRef = useRef(null);

  const handleSubmit = async (e) => {
    // e.preventDefault();
    // Auto-save signature
    if (isEdit) {
      if (!signaturePad.current || signaturePad.current.isEmpty()) {
        alert("Please provide a signature before proceeding.");
        return;
      }

      const signatureData = signaturePad.current.toDataURL("image/png");
      const base64String = signatureData.split(",")[1];
      const byteArray = new Uint8Array(
        atob(base64String)
          .split("")
          .map((c) => c.charCodeAt(0))
      );
      const blob = new Blob([byteArray], { type: "image/png" });
      const file = new File([blob], "signature.png", { type: "image/png" });

      setFormData((prevData) => ({
        ...prevData,
        signature_image: file,
      }));
    }

    if (step === 2) {
      if (!validate()) {
        return;
      }
      window.scrollTo(0, 0);
      setStep(3);
    } else if (step === 3) {
      const newErrors = {};
      if (!formState.tollsTicketAgree)
        newErrors.tollsTicketAgree = "You must agree to Tolls and Tickets.";
      if (!formState.disclosureAgree)
        newErrors.disclosureAgree = "You must agree to the Disclosure.";
      if (Object.values(formState.dos).some((checked) => !checked))
        newErrors.dos = "You must agree to all DO's.";
      if (Object.values(formState.donts).some((checked) => !checked))
        newErrors.donts = "You must agree to all DON'Ts.";
      if (!formState.dosAndDontsAgree)
        newErrors.dosAndDontsAgree = "You must agree to Do's & Dont's.";
      if (formState.parkingOption.length === 0)
        newErrors.parkingOption = "Please select at least one parking option.";
      if (
        formState.parkingOption.includes("Other") &&
        !formState.otherParkingOption
      )
        newErrors.otherParkingOption = "Please specify your parking option.";
      if (!formState.roadsideAssistant)
        newErrors.roadsideAssistant =
          "Please select a Roadside Assistant option.";
      if (!formState.insuranceAgree)
        newErrors.insuranceAgree = "You must agree to the Car Insurance terms.";

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
      }
      await handleSubmitImg();
      setSuccessModal(true);
    }
  };

  const confirmSubmit = async () => {
    setTermConditionModal(false);
    await handleSubmit();
    setSuccessModal(true);
  };

  useEffect(() => {
    if (termConditionModal) {
      const termsDiv = document.getElementById("terms_Contrrr");
      if (termsDiv) {
        const handleScroll = () => {
          const { scrollTop, scrollHeight, clientHeight } = termsDiv;

          // Check if the user has scrolled to the bottom
          if (scrollTop + clientHeight >= scrollHeight - 5) {
            setIsCheckboxEnabled(true); // Enable the checkbox
          } else {
            setIsCheckboxEnabled(false); // Disable the checkbox
          }
        };

        termsDiv.addEventListener("scroll", handleScroll);

        // Cleanup the event listener on modal close
        return () => {
          termsDiv.removeEventListener("scroll", handleScroll);
        };
      }
    }
  }, [termConditionModal]);

  useEffect(() => {
    if (licenseImage) {
      // Check if the license image URL ends with .pdf
      const isPdf = licenseImage.toLowerCase().endsWith(".pdf");
      setIsPdfFile(isPdf);
    }

    if (ridesharImag) {
      // Check if the license image URL ends with .pdf
      const isPdf2 = ridesharImag.toLowerCase().endsWith(".pdf");
      setIsPdfFile2(isPdf2);
    }
  }, [licenseImage,ridesharImag]);

  useEffect(() => {
    const allChecked =
      formState.terms1to3c &&
      formState.terms4to5 &&
      formState.tollsTicketAgree &&
      formState.disclosureAgree &&
      Object.values(formState.dos).every((checked) => checked) &&
      Object.values(formState.donts).every((checked) => checked) &&
      formState.dosAndDontsAgree &&
      formState.parkingOption.length > 0 &&
      (!formState.parkingOption.includes("Other") ||
        formState.otherParkingOption) &&
      formState.roadsideAssistant &&
      formState.insuranceAgree &&
      formState.paymentOption;

    setIsFinalCheckboxEnabled(allChecked);
  }, [formState]);

  function formatDateToYMD(dateObj) {
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  return (
    <Layout>
      <div>
        <div className="page-header pt-30 background-body">
          <div className="position-relative mx-auto">
            <div className="container">
              <h5 className="text-dark">Agreement Form</h5>
              {/* <span className="text-dark text-xl-medium">
                Start your car agreement booking by completing this quick 2-step
                application!
              </span> */}
            </div>
          </div>
          <div className="container">
            <div className="mt-4 mb-4 form-container">
              <form onSubmit={handleSubmit}>
                {step === 1 && (
                  <div className="form-step">
                    <h6 className="mb-4">Step 1: Basic Information</h6>
                    <div className="row m-0">
                      <label key="firstName" className="col-md-6 mb-3">
                        <span>
                          First Name <span style={{ color: "red" }}>*</span>
                        </span>
                        <input
                          type="text"
                          name="firstName"
                          value={formData.firstName}
                          onChange={(e) => {
                            handleChange(e);
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              firstName: "",
                            }));
                          }}
                          onKeyPress={(e) => {
                            if (!/^[a-zA-Z]*$/.test(e.key)) {
                              e.preventDefault(); // Allow only alphabets
                            }
                          }}
                          maxLength={12}
                          required
                          disabled
                        />
                        {errors.firstName && (
                          <span className="error-message">
                            {errors.firstName}
                          </span>
                        )}
                      </label>

                      <label key="lastName" className="col-md-6 mb-3">
                        <span>
                          Last Name <span style={{ color: "red" }}>*</span>
                        </span>
                        <input
                          type="text"
                          name="lastName"
                          value={formData.lastName}
                          maxLength={12}
                          onChange={(e) => {
                            handleChange(e);
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              lastName: "",
                            }));
                          }}
                          onKeyPress={(e) => {
                            if (!/^[a-zA-Z]*$/.test(e.key)) {
                              e.preventDefault(); // Allow only alphabets
                            }
                          }}
                          required
                          disabled
                        />
                        {errors.lastName && (
                          <span className="error-message">
                            {errors.lastName}
                          </span>
                        )}
                      </label>

                      <label key="phone" className="col-md-6 mb-3">
                        <span>
                          Phone Number <span style={{ color: "red" }}>*</span>
                        </span>
                        <input
                          type="tel"
                          name="phone"
                          maxLength={10}
                          value={formData.phone}
                          onChange={(e) => {
                            handleChange(e);
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              phone: "",
                            }));
                          }}
                          onKeyPress={(e) => {
                            if (!/^[0-9]*$/.test(e.key)) {
                              e.preventDefault(); // Allow only numbers
                            }
                          }}
                          required
                          disabled
                        />
                        {errors.phone && (
                          <span className="error-message">{errors.phone}</span>
                        )}
                      </label>

                      <label key="email" className="col-md-6 mb-3">
                        <span>
                          Email <span style={{ color: "red" }}>*</span>
                        </span>
                        <input
                          type="email"
                          name="email"
                          maxLength={50}
                          value={formData.email}
                          onChange={(e) => {
                            handleChange(e);
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              email: "",
                            }));
                          }}
                          required
                          disabled
                          onKeyPress={(e) => {
                            const allowedChars = /^[a-zA-Z0-9@.]*$/;
                            if (!allowedChars.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onBlur={(e) => {
                            const emailPattern =
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                            if (!emailPattern.test(e.target.value)) {
                              setErrors({
                                ...errors,
                                email: "Please enter a valid email address",
                              });
                            }
                          }}
                        />
                        {errors.email && (
                          <span className="error-message">{errors.email}</span>
                        )}
                      </label>

                      <label className="col-md-6 mb-3">
                        <span>
                          Date of Birth <span style={{ color: "red" }}>*</span>
                        </span>
                        <DatePicker
  selected={
    formData.dob && !isNaN(new Date(formData.dob).getTime())
      ? new Date(formData.dob)
      : null
  }
  onChange={(date) => {
    setFormData((prevData) => ({
      ...prevData,
      dob: formatDateToYMD(date),
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      dob: "",
    }));
  }}
  showMonthDropdown
  showYearDropdown
  dropdownMode="select"
  className="search-input datepicker"
  maxDate={maxDob}
  placeholderText="Select Date"
/>
                        {errors.dob && (
                          <span className="error-message">{errors.dob}</span>
                        )}
                      </label>

                      {/* Address */}
                      <label className="col-md-12 mb-3">
                        <span>
                          Street Address <span style={{ color: "red" }}>*</span>
                        </span>

                        {/* Street Address */}
                        <input
                          type="text"
                          name="address"
                          placeholder="Street Address"
                          value={formData.address}
                          maxLength={100}
                          onChange={(e) => {
                            handleChange(e);
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              address: "",
                            }));
                          }}
                          required
                          disabled
                          style={{
                            display: "block",
                            width: "100%",
                            marginBottom: "10px",
                          }}
                        />
                        {errors.address && (
                          <span className="error-message">
                            {errors.address}
                          </span>
                        )}

                        {/* City */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                          }}
                        >
                          <div className="col">
                            <input
                              type="text"
                              name="city"
                              placeholder="City"
                              value={formData.city}
                              maxLength={50}
                              onChange={(e) => {
                                handleChange(e);
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  city: "",
                                }));
                              }}
                              required
                              disabled
                              style={{
                                display: "block",
                                width: "100%",
                                marginBottom: "10px",
                              }}
                            />
                            {errors.city && (
                              <span className="error-message">
                                {errors.city}
                              </span>
                            )}
                          </div>

                          {/* State */}
                          <div className="col">
                            <select
                              name="drivingState"
                              value={formData.drivingState || ""}
                              onChange={(e) => {
                                handleChange(e);
                                if (errors.drivingState) {
                                  setErrors((prevErrors) => ({
                                    ...prevErrors,
                                    drivingState: "",
                                  }));
                                }
                              }}
                              required
                              disabled
                              style={{
                                backgroundColor: "#fff",
                                height: "50px",
                              }}
                            >
                              <option value="">Select a state</option>
                              {usStates.map((state) => (
                                <option key={state.name} value={state.name}>
                                  {state.name}
                                </option>
                              ))}
                            </select>
                            {errors.drivingState && (
                              <span style={{ color: "red" }}>
                                {errors.drivingState}
                              </span>
                            )}
                          </div>

                          {/* Zip Code */}
                          <div className="col">
                            <input
                              type="text"
                              name="zipcode"
                              placeholder="Zip Code"
                              value={formData.zipcode}
                              maxLength={5}
                              onChange={(e) => {
                                handleChange(e);
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  zipcode: "",
                                }));
                              }}
                              required
                              disabled
                              style={{ display: "block", width: "100%" }}
                            />
                            {errors.zipcode && (
                              <span className="error-message">
                                {errors.zipcode}
                              </span>
                            )}
                          </div>
                        </div>
                      </label>
                    </div>

                    {/* Submit Button */}
                    <div
                      className="submit-form-btn"
                      onClick={() => {
                        handleNext(); // Proceed to the next step
                      }}
                    >
                      Next
                    </div>
                  </div>
                )}

                {step === 2 && (
                  <div className="form-step ">
                    <h6 className="mb-4">Step 2: Rental Details</h6>
                    <div className="row m-0">
                      <label className="col-md-6 mb-3">
                        Last 4 of SSN <span style={{ color: "red" }}>*</span>
                        <input
                          type="text"
                          name="ssn"
                          value={formData.ssn}
                          maxLength={4}
                          onChange={(e) => {
                            handleChange(e);
                            if (errors.ssn) {
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                ssn: "",
                              }));
                            }
                          }}
                          required
                          placeholder="Enter Last 4 Digits of SSN"
                        />
                        {errors.ssn && (
                          <span style={{ color: "red" }}>{errors.ssn}</span>
                        )}
                      </label>
                      <label className="col-md-6 mb-3">
                        Select State <span style={{ color: "red" }}>*</span>
                        <select
                          name="licenseState"
                          value={formData.licenseState || ""}
                          onChange={(e) => {
                            handleChange(e);
                            if (errors.licenseState) {
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                licenseState: "",
                              }));
                            }
                          }}
                          required
                          style={{ backgroundColor: "#fff", height: "50px" }}
                        >
                          <option value="">Select a state</option>
                          {usStates.map((state) => (
                            <option key={state.name} value={state.name}>
                              {state.name}
                            </option>
                          ))}
                        </select>
                        {errors.licenseState && (
                          <span style={{ color: "red" }}>
                            {errors.licenseState}
                          </span>
                        )}
                      </label>

                      {/* License Expiry */}
                      <label className="col-md-6 mb-3">
                        <div
                          style={{ flexDirection: "column", display: "flex" }}
                        >
                          <span>
                            Expiration of Driving License{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                          <DatePicker
                            selected={formData.licenseExpiry}
                            onChange={(date) => {
                              setFormData((prevData) => ({
                                ...prevData,
                                licenseExpiry: formatDateToYMD(date),
                              }));
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                licenseExpiry: "",
                              }));
                            }}
                            dateFormat="yyyy-MM-dd"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="search-input datepicker"
                            minDate={new Date()}
                            placeholderText="Select Date"
                          />
                          {errors.licenseExpiry && (
                            <span
                              className="error-message"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {errors.licenseExpiry}
                            </span>
                          )}
                        </div>
                      </label>
                      <label className="col-md-6 mb-3">
                        Driver's License number{" "}
                        <span style={{ color: "red" }}>*</span>
                        <input
                          type="text"
                          name="license"
                          value={formData.license}
                          placeholder="Enter Your Driving License Number"
                          maxLength={14}
                          onChange={(e) => {
                            handleAlphabetsNumberWithoutSpaceChange(e);
                            handleChange(e);
                            if (errors.license) {
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                license: "",
                              }));
                            }
                            storeData("drving_licence_no", e.target.value)
                          }}
                          required
                        />
                        {errors.license && (
                          <span style={{ color: "red" }}>{errors.license}</span>
                        )}
                      </label>
                      <div className="col-md-6 mb-3">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "10px",
                            marginBottom: "8px",
                          }}
                        >
                          <label>
                            Drivers License{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          {licenseImage ? (
                            isPdfFile ? (
                              // For PDF files, provide a link to open in new tab
                              <a
                                href={licenseImage}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-primary"
                                style={{ padding: "2px 8px" }}
                              >
                                <Eye size={18} /> View PDF
                              </a>
                            ) : // For images, don't show any button
                            null
                          ) : (
                            <p style={{ color: "red" }}>No license uploaded</p>
                          )}
                        </div>

                        {/* Image Preview Area - always shown for images */}
                        {!isPdfFile && licenseImage && (
                          <div
                            style={{
                              marginTop: "10px",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              padding: "10px",
                            }}
                          >
                            <img
                              src={licenseImage}
                              alt="Driver's License"
                              style={{ width: "250px" }}
                              // onLoad={() =>
                              //   console.log("Image loaded successfully")
                              // }
                              onError={(e) => {
                                console.error("Error loading image:", e);
                                e.target.style.display = "none";
                                document.getElementById(
                                  "image-error"
                                ).style.display = "block";
                              }}
                            />
                            <div
                              id="image-error"
                              style={{
                                display: "none",
                                color: "red",
                                textAlign: "center",
                              }}
                            >
                              Unable to load image. <br />
                              <a
                                href={licenseImage}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-primary mt-2"
                                style={{
                                  fontSize: "14px",
                                  borderRadius: "8px",
                                  padding: "0.5rem 1rem",
                                }}
                              >
                                Open in New Tab
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "10px",
                            marginBottom: "8px",
                          }}
                        >
                          <label>
                            Driver's Rideshare Approval{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          {ridesharImag ? (
                            isPdfFile2 ? (
                              <a
                                href={ridesharImag}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-primary"
                                style={{ padding: "2px 8px" }}
                              >
                                <Eye size={18} /> View PDF
                              </a>
                            ) : 
                            null
                          ) : (
                            <p style={{ color: "red" }}>No Rideshare image uploaded</p>
                          )}
                        </div>

                        {!isPdfFile2 && ridesharImag && (
                          <div
                            style={{
                              marginTop: "10px",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              padding: "10px",
                            }}
                          >
                            <img
                              src={ridesharImag}
                              alt="Driver's License"
                              style={{ width: "250px" }}
                              onLoad={() =>
                                console.log("Image loaded successfully")
                              }
                              onError={(e) => {
                                console.error("Error loading image:", e);
                                e.target.style.display = "none";
                                document.getElementById(
                                  "image-error"
                                ).style.display = "block";
                              }}
                            />
                            <div
                              id="image-error"
                              style={{
                                display: "none",
                                color: "red",
                                textAlign: "center",
                              }}
                            >
                              Unable to load image. <br />
                              <a
                                href={ridesharImag}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-primary mt-2"
                                style={{
                                  fontSize: "14px",
                                  borderRadius: "8px",
                                  padding: "0.5rem 1rem",
                                }}
                              >
                                Open in New Tab
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                      {rideshare === "no" ? (
                        <label className="col-md-12 mb-3">
                          <span className="subLabel">
                            Using car for (Select all that apply){" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                          <div>
                            <label>
                              <input
                                type="checkbox"
                                name="carUsage"
                                value="Rideshare"
                                checked={formData.carUsage.includes(
                                  "Rideshare"
                                )}
                                onChange={(e) => {
                                  handleChange(e);
                                  if (errors.carUsage) {
                                    setErrors((prevErrors) => ({
                                      ...prevErrors,
                                      carUsage: "",
                                    }));
                                  }
                                }}
                              />
                              Rideshare
                            </label>
                            <label>
                              <input
                                type="checkbox"
                                name="carUsage"
                                value="Commute to work"
                                checked={formData.carUsage.includes(
                                  "Commute to work"
                                )}
                                onChange={(e) => {
                                  handleChange(e);
                                  if (errors.carUsage) {
                                    setErrors((prevErrors) => ({
                                      ...prevErrors,
                                      carUsage: "",
                                    }));
                                  }
                                }}
                              />
                              Commute to work
                            </label>
                            <label>
                              <input
                                type="checkbox"
                                name="carUsage"
                                value="Other"
                                checked={formData.carUsage.includes("Other")}
                                onChange={(e) => {
                                  handleChange(e);
                                  if (errors.carUsage) {
                                    setErrors((prevErrors) => ({
                                      ...prevErrors,
                                      carUsage: "",
                                    }));
                                  }
                                }}
                              />
                              Other
                            </label>
                            {formData.carUsage.includes("Other") && (
                              <input
                                type="text"
                                name="carUsageOther"
                                placeholder="Specify other usage"
                                value={formData.carUsageOther}
                                onChange={handleChange}
                              />
                            )}
                          </div>
                          {errors.carUsage && (
                            <span style={{ color: "red" }}>
                              {errors.carUsage}
                            </span>
                          )}
                        </label>
                      ) : (
                        <label className="col-md-12 mb-3">
                          <span className="subLabel">
                            Approved and ready to work for (Select all that
                            apply)
                            <span style={{ color: "red" }}>*</span>
                          </span>
                          <div>
                            <label>
                              <input
                                type="checkbox"
                                name="workApproval"
                                value="Uber"
                                checked={formData.workApproval.includes("Uber")}
                                onChange={(e) => {
                                  handleChange(e);
                                  if (errors.workApproval) {
                                    setErrors((prevErrors) => ({
                                      ...prevErrors,
                                      workApproval: "",
                                    }));
                                  }
                                }}
                              />
                              Uber
                            </label>
                            <label>
                              <input
                                type="checkbox"
                                name="workApproval"
                                value="GIG Work"
                                checked={formData.workApproval.includes(
                                  "GIG Work"
                                )}
                                onChange={(e) => {
                                  handleChange(e);
                                  if (errors.workApproval) {
                                    setErrors((prevErrors) => ({
                                      ...prevErrors,
                                      workApproval: "",
                                    }));
                                  }
                                }}
                              />
                              GIG Work
                            </label>
                            <label>
                              <input
                                type="checkbox"
                                name="workApproval"
                                value="Lyft"
                                checked={formData.workApproval.includes("Lyft")}
                                onChange={(e) => {
                                  handleChange(e);
                                  if (errors.workApproval) {
                                    setErrors((prevErrors) => ({
                                      ...prevErrors,
                                      workApproval: "",
                                    }));
                                  }
                                }}
                              />
                              Lyft
                            </label>
                            <label>
                              <input
                                type="checkbox"
                                name="workApproval"
                                value="Other"
                                checked={formData.workApproval.includes(
                                  "Other"
                                )}
                                onChange={(e) => {
                                  handleChange(e);
                                  if (errors.workApproval) {
                                    setErrors((prevErrors) => ({
                                      ...prevErrors,
                                      workApproval: "",
                                    }));
                                  }
                                }}
                              />
                              Other
                            </label>
                            {formData.workApproval.includes("Other") && (
                              <input
                                type="text"
                                name="workApprovalOther"
                                placeholder="Specify other platform"
                                value={formData.workApprovalOther}
                                onChange={handleChange}
                              />
                            )}
                          </div>
                          {errors.workApproval && (
                            <span style={{ color: "red" }}>
                              {errors.workApproval}
                            </span>
                          )}
                        </label>
                      )}

                      <h6>Emergency Contact 1</h6>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: "15px",
                        }}
                        className="col-md-12 mb-3 mt-2"
                      >
                        <div className="col-md-3">
                          {" "}
                          <label className="label768">
                            Name
                            <input
                              type="text"
                              name="name"
                              value={formData.emergencyContact1.name}
                              onChange={(e) => {
                                if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                  handleEmergencyChange(e, 1);
                                }
                              }}
                            />
                            {errors.emergencyContact1_name && (
                              <span className="error">
                                {errors.emergencyContact1_name}
                              </span>
                            )}
                          </label>
                        </div>
                        <div className="col-md-3">
                          <label className="label768">
                            Relation
                            <select
                              name="relation"
                              value={formData.emergencyContact1.relation}
                              onChange={(e) => handleEmergencyChange(e, 1)}
                            >
                              <option value="" hidden disabled>
                                Select Relation
                              </option>
                              <option value="Spouse">Father</option>
                              <option value="Spouse">Mother</option>
                              <option value="Spouse">Cousin</option>
                              <option value="Spouse">Spouse</option>
                              <option value="Siblings">Sibling</option>
                              <option value="Friends">Friend</option>
                              <option value="Grandparent">Grandparent</option>
                            </select>
                            {errors.emergencyContact1_relation && (
                              <span className="error">
                                {errors.emergencyContact1_relation}
                              </span>
                            )}
                          </label>
                        </div>
                        <div className="col-md-3">
                          {" "}
                          <label className="label768">
                            Phone
                            <input
                              type="tel"
                              name="phone"
                              value={formData.emergencyContact1.phone}
                              onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                  handleEmergencyChange(e, 1);
                                }
                              }}
                              maxLength={10}
                            />
                            {errors.emergencyContact1_phone && (
                              <span className="error">
                                {errors.emergencyContact1_phone}
                              </span>
                            )}
                          </label>
                        </div>
                      </div>

                      <h6>Emergency Contact 2</h6>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: "15px",
                        }}
                        className="col-md-12 mb-3 mt-2"
                      >
                        <div className="col-md-3">
                          {" "}
                          <label className="label768">
                            Name
                            <input
                              type="text"
                              name="name"
                              value={formData.emergencyContact2.name}
                              onChange={(e) => {
                                if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                  handleEmergencyChange(e, 2);
                                }
                              }}
                            />
                            {errors.emergencyContact2_name && (
                              <span className="error">
                                {errors.emergencyContact2_name}
                              </span>
                            )}
                          </label>
                        </div>
                        <div className="col-md-3">
                          <label className="label768">
                            Relation
                            <select
                              name="relation"
                              value={formData.emergencyContact2.relation}
                              onChange={(e) => handleEmergencyChange(e, 2)}
                            >
                              <option value="" hidden disabled>
                                Select Relation
                              </option>
                              <option value="Spouse">Father</option>
                              <option value="Spouse">Mother</option>
                              <option value="Spouse">Cousin</option>
                              <option value="Spouse">Spouse</option>
                              <option value="Siblings">Sibling</option>
                              <option value="Friends">Friend</option>
                              <option value="Grandparent">Grandparent</option>
                            </select>
                            {errors.emergencyContact2_relation && (
                              <span className="error">
                                {errors.emergencyContact2_relation}
                              </span>
                            )}
                          </label>
                        </div>
                        <div className="col-md-3">
                          {" "}
                          <label className="label768">
                            Phone
                            <input
                              type="tel"
                              name="phone"
                              value={formData.emergencyContact2.phone}
                              onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                  handleEmergencyChange(e, 2);
                                }
                              }}
                              maxLength={10}
                            />
                            {errors.emergencyContact2_phone && (
                              <span className="error">
                                {errors.emergencyContact2_phone}
                              </span>
                            )}
                          </label>
                        </div>
                        {errors.emergencyContactsame && (
                          <p style={{ color: "red" }}>
                            {errors.emergencyContactsame}
                          </p>
                        )}
                      </div>

                      <h6>Signature</h6>
                      <div className="signature-section mt-4 col-md-4 mb-3">
                        {/* <h5>Signature</h5> */}
                        {isEdit ? (
                          <SignatureCanvas
                            ref={signaturePad}
                            penColor="black"
                            canvasProps={{
                              height: 200,
                              width: 300,
                              className: "signature-canvas border rounded",
                            }}
                          />
                        ) : (
                          <img
                            className="signature-canvas border rounded"
                            src={signatureFile}
                          />
                        )}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          {isEdit ? (
                            <>
                              <div
                                // type="button"
                                className="submit-form-btn-small"
                                onClick={handleClearSignature}
                              >
                                Clear
                              </div>
                              <div
                                // type="button"
                                className="submit-form-btn-small2"
                                onClick={handleEditSignature}
                              >
                                Cancel
                              </div>
                            </>
                          ) : (
                            <div
                              // type="button"
                              className="submit-form-btn-small"
                              onClick={handleEditSignature}
                            >
                              Edit
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div className="submit-form-btn" onClick={handleBack}>
                        Back
                      </div>

                      <div className="submit-form-btn" onClick={handleSubmit}>
                        Next
                      </div>
                    </div>
                  </div>
                )}

                {step === 3 && (
                  <div className="form-step">
                    <h2 className="terms-heading">
                      Parking & Roadside Assistance
                    </h2>
                    <p className="terms-point terms-bold">
                      Where will you Park car?*
                    </p>
                    <div className="terms-checkbox-group">
                      {[
                        "Parking Lot - Need Tag or Sticker",
                        "Parking Lot - No Need Tag or Sticker",
                        "Street Parking",
                        "Drive-way",
                        "Private Garage",
                        "Other",
                      ].map((option) => (
                        <div className="check_box_dvv" key={option}>
                          <input
                            type="checkbox"
                            id={option.replace(/\s+/g, "")}
                            name="parkingOption"
                            value={option}
                            checked={formState.parkingOption.includes(option)}
                            onChange={(e) => {
                              const value = e.target.value;
                              setFormState((prev) => ({
                                ...prev,
                                parkingOption: prev.parkingOption.includes(
                                  value
                                )
                                  ? prev.parkingOption.filter(
                                      (item) => item !== value
                                    )
                                  : [...prev.parkingOption, value],
                              }));
                            }}
                          />
                          <label htmlFor={option.replace(/\s+/g, "")}>
                            {option}
                          </label>
                        </div>
                      ))}
                      {formErrors.parkingOption && (
                        <span className="error-message">
                          {formErrors.parkingOption}
                        </span>
                      )}
                    </div>
                    {formState.parkingOption.includes("Other") && (
                      <div className="terms-input-group">
                        <p className="terms-point">
                          Please specify your parking option:
                        </p>
                        <input
                          className="terms-input"
                          type="text"
                          id="otherParkingOption"
                          name="otherParkingOption"
                          value={formState.otherParkingOption}
                          onChange={(e) =>
                            setFormState({
                              ...formState,
                              otherParkingOption: e.target.value,
                            })
                          }
                          placeholder="Enter your parking option"
                        />
                      </div>
                    )}

                    <p className="terms-point terms-bold mt-3">
                      Recommended AAA Road Side Assistant.*
                      <br />
                      <span style={{ fontSize: "14px", color: "grey" }}>
                        (We provide 4 events per year to the premium members)
                      </span>
                    </p>
                    <div className="terms-radio-group">
                      {[
                        "I have AAA",
                        "May decide later. (Your will be responsible to any Roadside Assistant : need for Jump / putting Donut / locked out etc. It may be available through Uber/Lyft or otherwise)",
                      ].map((option) => (
                        <div className="check_box_dvv" key={option}>
                          <input
                            type="radio"
                            id={option.substring(0, 10).replace(/\s+/g, "")}
                            name="roadsideAssistant"
                            value={option}
                            checked={formState.roadsideAssistant === option}
                            onChange={(e) =>
                              setFormState({
                                ...formState,
                                roadsideAssistant: e.target.value,
                              })
                            }
                          />
                          <label
                            htmlFor={option
                              .substring(0, 10)
                              .replace(/\s+/g, "")}
                          >
                            {option}
                          </label>
                        </div>
                      ))}
                      {formErrors.roadsideAssistant && (
                        <span className="error-message">
                          {formErrors.roadsideAssistant}
                        </span>
                      )}
                    </div>

                    <div className="row m-0">
                      <div className="terms-then">
                        {/* Standardized New Content Starts Here */}
                        <h2 className="terms-heading">
                          Agreement for Car Rent, Tolls and Tickets for Rental
                          Vehicle
                        </h2>
                        <p className="terms-point">
                          <span className="terms-bold">OWNER:</span>{" "}
                          {formData.company_name}
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">RENTER:</span>{" "}
                          {formData.firstName} {formData.lastName}
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">CAR INFO:</span>{" "}
                          {cardatabooking.car_name || "NA"} / LP#:{" "}
                          {cardatabooking.car_no || "NA"} VIN#:{" "}
                          {cardatabooking.vin || "NA"} / Make Year:{" "}
                          {cardatabooking.make_year || "NA"} / Model:{" "}
                          {cardatabooking.model_name || "NA"}
                        </p>
                        <p className="terms-point">
                          I {formData.firstName} {formData.lastName}, will be
                          liable and pay Car Rent regularly and for any Tolls /
                          Tickets come on the above rental car from pickup
                          date to drop-off date.
                        </p>
                        <p className="terms-point">
                          I acknowledge that I am also liable to pay any all
                          fines, penalties, traffic and/or parking violations,
                          tolls fees, court costs, towing and impound charges,
                          and other expenses relating to the Vehicle assessed
                          for the above period.
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">IPass Transponder#</span>{" "}
                          {cardatabooking.ipass_number || "Not Assigned"}
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">Driver License#</span>{" "}
                          {formData?.license || "NA"}
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">
                            Present Residential Address:
                          </span>{" "}
                          {formData.address} {formData.city}{" "}
                          {formData.drivingState} {formData.zipcode}
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">Phone#:</span>{" "}
                          {formData.phone}
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">Email:</span>{" "}
                          {formData.email}
                        </p>
                        <div className="terms-agree-section">
                          <p className="terms-agree-title">
                            Agree for Tolls and Ticket*
                          </p>
                          <div className="check_box_dvv">
                            <input
                              type="checkbox"
                              name="tollsTicketAgree"
                              checked={formState.tollsTicketAgree}
                              onChange={(e) =>
                                setFormState({
                                  ...formState,
                                  tollsTicketAgree: e.target.checked,
                                })
                              }
                            />
                            <label>Yes, Agree for Tolls and Ticket</label>
                          </div>
                          {formErrors.tollsTicketAgree && (
                            <span className="error-message">
                              {formErrors.tollsTicketAgree}
                            </span>
                          )}
                        </div>

                        <h2 className="terms-heading">
                          DISCLOSURE AUTHORIZATION FORM
                        </h2>
                        <p className="terms-point">
                          <span className="terms-bold">CAR INFO:</span>{" "}
                          {cardatabooking.car_name} / LP#:{" "}
                          {cardatabooking.car_no} VIN#: {cardatabooking.vin} /
                          Make Year: {cardatabooking.make_year}/ Model:{" "}
                          {cardatabooking.model_name}
                        </p>
                        <p className="terms-point">
                          I {bookingCarData.name}, use the above-mentioned
                          vehicle for Rideshare / other platform. I authorize
                          the owner of the Vehicle to obtain information /
                          incident report from my Rideshare / other platform
                          such as, but not limited to usingCar
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">
                            My Phone Number is :
                          </span>{" "}
                          {bookingCarData.mobile_no}
                          {/* mobile_no */}
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">Email:</span>{" "}
                          {bookingCarData.email}
                        </p>
                        <div className="terms-agree-section">
                          <p className="terms-agree-title">
                            Agree for the Disclosure?*
                          </p>
                          <div className="check_box_dvv">
                            <input
                              type="checkbox"
                              name="disclosureAgree"
                              checked={formState.disclosureAgree}
                              onChange={(e) =>
                                setFormState({
                                  ...formState,
                                  disclosureAgree: e.target.checked,
                                })
                              }
                            />
                            <label>Yes, Agree for Disclosure</label>
                          </div>
                          {formErrors.disclosureAgree && (
                            <span className="error-message">
                              {formErrors.disclosureAgree}
                            </span>
                          )}
                        </div>

                        <h2 className="terms-heading">DO's & DONT's</h2>
                        <p className="terms-point terms-bold">DO's</p>
                        <ul className="point_agry_terms">
                          {[
                            "More than 1/4 tank gas should be always maintained. If you run out of gas, $90 will be charged for the Roadside Assistant.",
                            "Any new warning sign or driving issues should be reported immediately and do not keep driving.",
                            "Coming for Bi-weekly Servicing is mandatory. If you MISS your bi-weekly car service, you will be responsible for any damage to the engine or other parts.",
                            "Parking and car safety is renter's responsibility. If you need parking permit or tags, please make sure you have it on the car.",
                            "If your car is towed away for any reason, report us immediately. You will have to pay charges for the towing / impound, etc.",
                            "Check Oil and Coolant level once a week.",
                          ].map((item, index) => (
                            <li key={`do-${index}`}>
                              <div className="check_box_dvv">
                                <input
                                  type="checkbox"
                                  name={`do${index}`}
                                  checked={formState.dos[item]}
                                  onChange={(e) =>
                                    setFormState({
                                      ...formState,
                                      dos: {
                                        ...formState.dos,
                                        [index]: item,
                                      },
                                    })
                                  }
                                />
                                <label>{item}</label>
                              </div>
                            </li>
                          ))}
                        </ul>

                        <p className="terms-point terms-bold">DONT's</p>
                        <ul className="point_agry_terms">
                          {[
                            "Cannot leave car running while step out of car while Pickup / drop offs, filling gas, etc.",
                            "Do not leave running Blinkers / fan / radio etc. when you leave your car as it will drain the battery. If you drain the Battery, $90 will be charged for the Roadside Assistant.",
                            "Cannot leave car keys in the car any time. Should be always in renter's possession. $90 will be charged for the Roadside Assistant.",
                            "Cannot allow any other person / family / friend to operate the rented vehicle.",
                            "Do not bring any family members/ kids/ elderly person with you when you come for car service due to safety reasons.",
                            "Cannot release car to any towing company / repair shop other than authorized by company. You will be responsible to the cost.",
                            "Cannot keep driving and damage tire and wheel of the car if there is nail or low air. In the event of damage renter is responsible for the cost of repair. $90 will be charged for the Roadside Assistant.",
                          ].map((item, index) => (
                            <li key={`dont-${index}`}>
                              <div className="check_box_dvv">
                                <input
                                  type="checkbox"
                                  name={`dont${index}`}
                                  checked={formState.donts[item]}
                                  onChange={(e) =>
                                    setFormState({
                                      ...formState,
                                      donts: {
                                        ...formState.donts,
                                        [index]: item,
                                      },
                                    })
                                  }
                                />
                                <label>{item}</label>
                              </div>
                            </li>
                          ))}
                        </ul>
                        <div className="terms-agree-section">
                          <p className="terms-agree-title">
                            Agree for Do's & Dont's?*
                          </p>
                          <div className="check_box_dvv">
                            <input
                              type="checkbox"
                              name="dosAndDontsAgree"
                              checked={formState.dosAndDontsAgree}
                              onChange={(e) =>
                                setFormState({
                                  ...formState,
                                  dosAndDontsAgree: e.target.checked,
                                })
                              }
                            />
                            <label>Yes, Agree for Do's & Dont's</label>
                          </div>
                          {formErrors.dosAndDontsAgree && (
                            <span className="error-message">
                              {formErrors.dosAndDontsAgree}
                            </span>
                          )}
                        </div>

                        <h2 className="terms-heading">
                          Agreement of Terms and Condition for Car Insurance
                        </h2>
                        <p className="terms-point">
                          <span className="terms-bold">
                            Company / Car Owner:
                          </span>{" "}
                          {bookingCarData.insurance_company}
                          {/* company_name */}
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">Address:</span>{" "}
                          {bookingCarData.company_address}
                          {/* company_address */}
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">Driver:</span>{" "}
                          {bookingCarData.name}
                          {/* last_name */}
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">DL #:</span>{" "}
                          {formData?.license || "NA"}
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">Insurance Policy#:</span>{" "}
                          {bookingCarData.insurance_policy}
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">Car:</span>{" "}
                          {cardatabooking.car_name}
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">VIN:</span>{" "}
                          {cardatabooking.vin}
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">Insurance Issue date</span>{" "}
                          {formatDate1(bookingCarData.insurance_start_date)} {" "}
                        </p>
                        <p className="terms-point">
                          The above company/owner will be lien Holder / Lessor/
                          additional interest and loss payee for the above
                          policy. Any Refund at the time of cancellation or
                          payments will be directly sent to the company / Owner.
                        </p>
                        <div className="terms-agree-section">
                          <p className="terms-agree-title">
                            Agreement for Terms and Condition for Car Insurance*
                          </p>
                          <div className="check_box_dvv">
                            <input
                              type="checkbox"
                              id="insuranceAgree"
                              name="insuranceAgree"
                              checked={formState.insuranceAgree}
                              onChange={(e) =>
                                setFormState({
                                  ...formState,
                                  insuranceAgree: e.target.checked,
                                })
                              }
                            />
                            <label htmlFor="insuranceAgree">Accept</label>
                          </div>
                          {formErrors.insuranceAgree && (
                            <span className="error-message">
                              {formErrors.insuranceAgree}
                            </span>
                          )}
                        </div>

                        {/* <h2 className="terms-heading">Card Authorization</h2>
                        <p className="terms-point">
                          I hereby affirm that I am the owner of the credit /
                          debit card used to make payments and that my name is
                          listed on the front of the credit card.
                        </p>
                        <p className="terms-point">
                          Any payment made for the car rental and other charges
                          such as Tickets, Tolls, Unpaid rent, Repossession,
                          Impounding, Towing, Damage, Cleaning etc ARE
                          NON-REFUNDABLE.
                        </p>
                        <p className="terms-point">
                          I will not use the card which is not on my name for
                          the rental payment.
                        </p>
                        <p className="terms-point">
                          I will be personally responsible for all the dues and
                          payments made.
                        </p>
                        <p className="terms-point">
                          <span className="terms-bold">Car Rent:</span> $car
                          Price
                        </p>

                        <p className="terms-point terms-bold">
                          How you want to pay?*
                        </p>
                        <div className="terms-radio-group">
                          {["Cash", "Card", "Already Paid"].map((option) => (
                            <div className="check_box_dvv" key={option}>
                              <input
                                type="radio"
                                id={option.replace(/\s+/g, "")}
                                name="paymentOption"
                                value={option}
                                checked={formState.paymentOption === option}
                                onChange={(e) =>
                                  setFormState({
                                    ...formState,
                                    paymentOption: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor={option.replace(/\s+/g, "")}>
                                {option}
                              </label>
                            </div>
                          ))}
                          {formErrors.paymentOption && (
                            <span className="error-message">
                              {formErrors.paymentOption}
                            </span>
                          )}
                        </div> */}

                        {/* Final Agreement Checkbox */}
                        {/* <div className="terms-agree-section">
                          <div className="check_box_dvv">
                            <input
                              name="agreed2"
                              className="cb-remember"
                              type="checkbox"
                              checked={agreed2}
                              disabled={!isFinalCheckboxEnabled}
                              onChange={(e) => setAgreed2(e.target.checked)}
                            />
                            <label>
                              I have read and agree to all terms and conditions.
                            </label>
                            {errors.agreed2 && (
                              <span style={{ color: "red" }}>
                                {errors.agreed2}
                              </span>
                            )}
                          </div>
                        </div> */}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: "20px",
                      }}
                    >
                      <div className="submit-form-btn" onClick={handleBack}>
                        Back
                      </div>
                      <div
                        className="submit-form-btn"
                        onClick={() => validateTerms()}
                        // disabled={!agreed2}
                        // style={{ opacity: agreed2 ? 1 : 0.5 }}
                      >
                        Submit
                      </div>
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>

      {/**----------t & C modal---------------- */}
      <Modal
        show={termConditionModal}
        onHide={() => setTermConditionModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <p className="modl_title_tc_head">
              {" "}
              Terms and Conditions for Agreement to Rent Vehicle
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="terms_Contrrr" className="terms_Contrrr" ref={termsRef}>
            <p style={{ marginBottom: "10px" }}>
              <span style={{ fontWeight: "bold" }}>1.</span> The vehicle may be
              driven during the rental term only by the persons named in this
              Document.
            </p>
            <p style={{ marginBottom: "10px" }}>
              <span style={{ fontWeight: "bold" }}>2.</span> The renter shall
              pay the rent rental of the vehicle the sum or sums specified in
              this Document; and authorizes the owner to charge all amounts
              payable to the renter's account. The renter's account means a
              nominated debit card, credit card, or pre-arranged charge account.
            </p>
            <p style={{ marginBottom: "10px" }}>
              <span style={{ fontWeight: "bold" }}>3.</span> In addition to the
              payment specified in clause 2 above, the renter acknowledges that
              they shall be liable for the rental term any applicable additional
              charges payable at the end of the term. These include, but are not
              limited to:
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(a.)</span> Charges for gas
              or other fuel used; Road user charges / Toll Charges; Charges for
              late return of the vehicle etc;
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(b.)</span> Charges for
              cleaning the vehicle's interior, if the vehicle is returned in a
              dirty condition that requires extra cleaning or deodorizing. This
              includes, but is not limited to, spillage of fluids, food, vomit,
              other stains, and unpleasant odors including cigarette smoke.
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(c.)</span> Liability of
              Traffic and/or parking Tickets / offence infringement fees.
            </p>

            <h2
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                marginTop: "20px",
                marginBottom: "20px",
                textAlign: "center",
                color: "#333",
                lineHeight: "20px",
              }}
            >
              Terms and Conditions for Agreement to Rent Vehicle
            </h2>

            <p style={{ marginBottom: "10px" }}>
              <span style={{ fontWeight: "bold" }}>4.</span> The renter shall
              NOT:
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(a.)</span> Sublet or rental
              the vehicle to any other person.
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(b.)</span> Allow the vehicle
              to be used outside his/her authority.
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(c.)</span> Operate the
              vehicle or allow it to be operated in circumstances that
              constitute an offence against any of Sections 56, 57 or 58 of the
              Act (which relates to driving under the influence of alcohol or
              drugs).
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(d.)</span> Operate the
              vehicle or allow it to be operated in any race, speed test,
              reliability trial, rally, or contest, or operated on any race or
              rally circuit or in any event as a pacemaker or testing in
              preparation for any of them.
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(e.)</span> Operate the
              vehicle or allow it to be operated, in breach of the Act, the Land
              Transport (Road User) Rule 2004, or any other Act, regulations,
              rules or bylaws relating to road traffic.
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(f.)</span> Operate the
              vehicle or allow it to be operated for the transport of more
              passengers or goods than the maximum specified in the certificate
              of loading and/or road user charge certificate, whichever is the
              lesser, for the vehicle.
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(g.)</span> Drive or allow
              the vehicle to be driven on any roads excluded in clause 22(q) of
              these terms and conditions, or on any beach, driveway, or surface
              likely to damage the vehicle.
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(h.)</span> Allow the vehicle
              to be driven by any person who is not named or described in the
              Rental Document as a person permitted to drive the vehicle.
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(i.)</span> Operate the
              vehicle or allow it to be operated to propel or tow any other
              vehicle.
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(j.)</span> Operate or allow
              the vehicle to be used in involvement with any illegal activity.
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(k.)</span> Do Smoking or do
              any illegal drugs in the vehicle.
            </p>
            <p style={{ marginBottom: "15px" }}>
              <span style={{ fontWeight: "bold" }}>5. RETURN OF VEHICLE:</span>{" "}
              The renter shall, at or before the expiry of the term of rental,
              deliver the vehicle to the agreed rental location described in the
              Rental Document or obtain the owner's consent to the continuation
              of the rental (in which case the renter shall pay additional
              rental charges for the extended term of rental). If the renter
              does not comply with this clause, and does not immediately return
              the vehicle, the owner may report the vehicle as stolen to the
              Police and the renter must compensate the owner for either the
              full cost of the vehicle, or all additional costs and losses
              incurred up to the time that the vehicle is recovered by the
              owner.
            </p>

            <h2
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                marginTop: "20px",
                marginBottom: "20px",
                textAlign: "start",
                color: "black",
                lineHeight: "20px",
              }}
            >
              Terms and Conditions for Agreement to Rent Vehicle
            </h2>

            <p
              style={{
                marginBottom: "15px",
                fontWeight: "bold",
                fontSize: "13px",
                color: "#333",
                backgroundColor: "#f5f5f5",
                padding: "10px",
                borderRadius: "5px",
                textAlign: "start",
              }}
            >
              6. READ AND ACCEPT FOLLOWING CONDITIONS OF RENTAL AGREEMENT: *
            </p>
            <ul className="point_agry_terms">
              <li>
                OWNER requires that all vehicles to be brought bi-weekly for
                vehicle servicing.<span>.</span>
              </li>
              <li>
                Any issues with the vehicle must be immediately reported.
                <span>.</span>
              </li>
              <li>
                The owner has the right to terminate the rental and take
                immediate possession of the vehicle, if the renter fails to
                comply with any of the terms of the Rental Agreement or if the
                vehicle is damaged.<span>.</span>
              </li>
              <li>
                Key damage / loss charge is $250<span>.</span>
              </li>
              <li>
                Repossession Charge is $250<span>.</span>
              </li>
              <li>
                Late fee is $10 Per day<span>.</span>
              </li>
              <li>
                Car will be picked up in case of non-payment for extending lease
                period.<span>.</span>
              </li>
              <li>
                If there is any payment is balance, recovery action will be
                taken.<span>.</span>
              </li>
              <li>
                Deposit if any will be forfeited and will be treated as car
                recovery fees.<span>.</span>
              </li>
              <li>
                I understand that any payment made is not refundable.
                <span>.</span>
              </li>
            </ul>

            <p style={{ marginBottom: "10px" }}>
              <span style={{ fontWeight: "bold" }}>
                7. Damage to the vehicle:
              </span>{" "}
              You will be personally responsible for any damage to the car.
            </p>
            <p style={{ marginBottom: "10px" }}>
              <span style={{ fontWeight: "bold" }}>8.</span> DO NOT Leave car
              keys in the car and turnoff the car when you leave the car.
            </p>
            <p style={{ marginBottom: "10px" }}>
              <span style={{ fontWeight: "bold" }}>9.</span> If car is Stolen /
              lost due to negligence, Renter will be responsible to pay the cost
              of car to the owner.
            </p>
            <p style={{ marginBottom: "10px" }}>
              <span style={{ fontWeight: "bold" }}>10.</span> In any event, the
              car will be released only to owner's authorize person / towing
              Company
            </p>
            <p style={{ marginBottom: "10px" }}>
              <span style={{ fontWeight: "bold" }}>11. Deductibles:</span> $1000
              per incident will be driver's responsibility. Rideshare platforms
              deductibles may be $2500 per incident.
            </p>
            <p
              style={{
                marginBottom: "10px",
                fontWeight: "bold",
                color: "#333",
              }}
            >
              Owner Responsibility: Vehicle Insurance & Maintenance.
            </p>
            <p
              style={{
                marginBottom: "10px",
                fontWeight: "bold",
                color: "#333",
              }}
            >
              OWNER, owner's Management, and its employees are NOT responsible
              for:
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(a.)</span> Any fault of the
              vehicle, any accidents, incident, unknown issues, natural cause,
              including any injury / death.
            </p>
            <p style={{ marginBottom: "10px", paddingLeft: "20px" }}>
              <span style={{ fontWeight: "bold" }}>(b.)</span> Anything not
              covered by insurance, things left in the car after you drop-off or
              we have repossessed the car. Any driving/ speeding/ parking
              tickets.
            </p>
          </div>

          <div
            className="check_box_dvv"
            style={{ opacity: isCheckboxEnabled ? 1 : 0.5 }}
          >
            <input
              name="agreed2"
              className="cb-remember"
              type="checkbox"
              checked={agreed2}
              disabled={!isCheckboxEnabled}
              onChange={(e) => setAgreed2(e.target.checked)}
            />{" "}
            <label>I have read and agree to the terms and conditions. </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="fottr_bttns">
            <Button
              variant="secondary"
              className="nobttn"
              onClick={() => setTermConditionModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="yesBttn"
              onClick={confirmSubmit}
              disabled={!agreed2}
              style={{ opacity: agreed2 ? 1 : 0.5 }}
            >
              Yes
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        show={successModal}
        onHide={() => {
          setSuccessModal(false);
          navigate("/my_bookings");
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Agreement Form Submission Successful</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="successMessage">
            Thank you for submitting your Agreement!
          </p>
          <p className="detailsText">
            Your Agreement has been received and is being processed. Our team
            will review your information and contact you shortly.
          </p>
          <hr className="divider" />
          <h3 className="nextStepsTitle">Next Steps:</h3>
          <p className="nextStepsText">
            1. You will receive a confirmation email shortly.
          </p>
          <p className="nextStepsText">
            2. Our team will verify your information within 24-48 hours and
            start the Handover Process.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              setSuccessModal(false);
              navigate("/my_bookings");
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
};

export default Agreement;
